import { createApi } from '@reduxjs/toolkit/query/react';
import { backend_server_address } from '../../../../../backendServer';
import { axiosBaseQuery } from '../../../../../store/utility';

export const devicesAPI = createApi({
    reducerPath: 'devicesAPI',
    baseQuery: axiosBaseQuery({ baseUrl: `${backend_server_address}/api/devices/`, arrayParamsSerializer: true }),
    tagTypes: ['Device'],
    endpoints: (builder) => ({
        getList: builder.query({
            query: (params) => ({
                url: '',
                method: 'GET',
                withCredentials: true,
                params,
            }),
            providesTags: (result) => {
                return result
                    ? [...result.map((device: any) => ({ type: 'Device', id: device.id })), 'Device']
                    : ['Device'];
            },
        }),
    }),
});

export const { endpoints, useLazyGetListQuery, useGetListQuery } = devicesAPI;
export const devicesAPIReducer = devicesAPI.reducer;
export const devicesAPIReducerPath = devicesAPI.reducerPath;
export const devicesAPIReducerMiddleware = devicesAPI.middleware;
